import React from 'react'
import { cn } from '@/lib/utils'

export function SegmentedTabs({
  tabs,
  activeTab,
  onTabChange,
  className,
}) {
  return (
    <div
      className={cn(
        'inline-flex p-1 rounded-2xl bg-black/[0.04] dark:bg-white/[0.06] border border-black/[0.05] dark:border-white/[0.06]',
        className,
      )}
    >
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id
        const Icon = tab.icon
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={cn(
              'flex items-center gap-2 px-4 py-2 rounded-xl text-sm font-medium transition-all duration-200',
              isActive
                ? 'bg-white dark:bg-white/[0.12] text-foreground shadow-sm border border-black/[0.06] dark:border-white/[0.1]'
                : 'text-muted-foreground hover:text-foreground hover:bg-black/[0.04] dark:hover:bg-white/[0.06]',
            )}
          >
            {Icon && (
              <Icon
                className={cn(
                  'h-4 w-4',
                  isActive ? 'text-primary' : 'text-muted-foreground',
                )}
              />
            )}
            {tab.label}
          </button>
        )
      })}
    </div>
  )
}
